module.exports = __webpack_public_path__ + "img/web elements-03.474145d1.png";